/* eslint-disable */
import * as React from 'react';
import { btnStyle, btnStyleActive } from '../../pages/styles';
import arrow from '../../assets/arrow.png';
import { LoadingButton } from '@mui/lab';

type HeaderProps = {
  onSubmit: any;
  disabled: boolean;
  loading: boolean;
  text: string;
  hasNoImage?: boolean;
  customStyle?: React.CSSProperties;
};

export const MuiButton = (props: HeaderProps) => {
  return (
    <LoadingButton
      loading={props.loading}
      type='submit'
      color='primary'
      variant='contained'
      disabled={props.disabled}
      style={props.customStyle ?? (props.disabled ? btnStyle : btnStyleActive)}
      fullWidth
      onClick={(e) => {
        props.onSubmit(e);
      }}
    >
      {props.text}
      {!props.hasNoImage && <img src={arrow} style={{ marginLeft: '9px' }} />}
    </LoadingButton>
  );
};
